import React from "react";

import { Container } from "react-bootstrap";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper.scss";

import {
  CompanionImgWrapper,
  CompanionsWrapper,
  SectionTitleH3,
  SingleCompanionCard,
} from "./styledCompanions";

import { StyledTooltip } from "../../../../style/base/base";

const CompanionsSectionComponent = ({ companions }) => {
  return (
    <section className="py-5">
      <Container>
        <CompanionsWrapper className="px-2 px-md-5 position-relative">
          <SectionTitleH3 className="position-absolute">همراهان آزتو</SectionTitleH3>
          <Swiper
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            spaceBetween={10}
            slidesPerView={2}
            breakpoints={{
              576: {
                slidesPerView: 3,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            }}
            loop={true}
            modules={[Autoplay]}
          >
            {companions.map((item) => {
              return (
                <SwiperSlide key={item.id}>
                  <StyledTooltip placement="top" title={item.title}>
                    <SingleCompanionCard
                      href={item.href}
                      target="_blank"
                      className="ّmx-auto"
                    >
                      <CompanionImgWrapper className="text-center">
                        <img src={item.img} alt={item.title} className="img-fluid" />
                      </CompanionImgWrapper>
                      <h5 className="text-center">{item.title}</h5>
                    </SingleCompanionCard>
                  </StyledTooltip>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </CompanionsWrapper>
      </Container>
    </section>
  );
};

export default CompanionsSectionComponent;
